import React from 'react';
import { Strong } from '../../../../../components/atoms/Strong/Strong';
import { HiddenParam, Option, Row, Select, SelectParam } from '../../../../../_lib/Form2';
import { useSonTranslation } from '../../../../../translation/useSonTranslation';
import { HiddenInput } from '../../../../../_lib/Form2/elements/HiddenInput/HiddenInput';

export type TeamRoomAdmissionTypeOptions = { value: 'open' | 'closed'; text: string };

type TeamroomFormTemplateProperties = {
  teamroomAdmissionTypeParam: SelectParam<'teamroomAdmissionType', TeamRoomAdmissionTypeOptions>;
  teamroomOnlyRequestedParam?: HiddenParam<'teamroomOnlyRequested'>;
};

export function TeamroomFormTemplate({
  teamroomAdmissionTypeParam,
  teamroomOnlyRequestedParam,
}: TeamroomFormTemplateProperties) {
  const { t } = useSonTranslation('CreatePage');

  return (
    <>
      <Row>
        <Select
          label={t(`PageManagement:views.create-page-general.inputs.${teamroomAdmissionTypeParam.name}.label`)}
          param={teamroomAdmissionTypeParam}
        >
          {teamroomAdmissionTypeParam.options.map(option => (
            <Option
              key={option.value}
              label={t(
                `PageManagement:views.create-page-general.inputs.teamroomAdmissionType.options.${option.value}.text`
              )}
              value={option.value}
            >
              {t(`PageManagement:views.create-page-general.inputs.teamroomAdmissionType.options.${option.value}.text`)}
            </Option>
          ))}
        </Select>
      </Row>
      {teamroomOnlyRequestedParam ? (
        <>
          <p className="create-page-form__teamroom-admission-text font-regular-14-19">
            <Strong>{t('teamroomAdmission.requestWarning')}</Strong> {t('teamroomAdmission.requestNotice')}
          </p>
          <HiddenInput {...teamroomOnlyRequestedParam} />
        </>
      ) : null}
    </>
  );
}
